export const myCommunity = {
  // Page titles and navigation
  'backoffice.myCommunity.genealogyTreeTitle': 'Árbol Genealógico',
  'backoffice.myCommunity.organizationalChart': 'Organigrama',
  'backoffice.myCommunity.treeViewTitle': 'Vista de Árbol',
  'backoffice.myCommunity.membersTitle': 'Miembros de la Comunidad',
  'backoffice.myCommunity.genealogyTreeSubtitle': 'Explora tu jerarquía completa de referidos',
  'backoffice.myCommunity.treeViewSubtitle': 'Vista en tabla de tu Comunidad',
  'backoffice.myCommunity.membersSubtitle': 'Lista de todos tus referidos directos e indirectos',

  // Common labels
  'backoffice.myCommunity.username': 'Nombre de Usuario',
  'backoffice.myCommunity.status': 'Estado',
  'backoffice.myCommunity.rank': 'Rango',
  'backoffice.myCommunity.level': 'Nivel',
  'backoffice.myCommunity.joinDate': 'Fecha de Registro',
  'backoffice.myCommunity.country': 'País',
  'backoffice.myCommunity.active': 'Activo',
  'backoffice.myCommunity.inactive': 'Inactivo',
  'backoffice.myCommunity.loading': 'Cargando...',
  'backoffice.myCommunity.loadMore': 'Cargar Más',
  'backoffice.myCommunity.expand': 'Expandir',
  'backoffice.myCommunity.collapse': 'Contraer',
  'backoffice.myCommunity.resetView': 'Restablecer Vista',
  'backoffice.myCommunity.memberSince': 'Miembro desde',
  'backoffice.myCommunity.comingSoon': 'Próximamente...',

  // Tree specific
  'backoffice.myCommunity.directReferrals': 'Referidos Directos',
  'backoffice.myCommunity.treeLevel': 'Nivel del Árbol',
  'backoffice.myCommunity.zoomIn': 'Acercar',
  'backoffice.myCommunity.zoomOut': 'Alejar',
  
  // Members specific
  'backoffice.myCommunity.totalUsers': 'Total de Usuarios',
  'backoffice.myCommunity.activeUsers': 'Usuarios Activos',
  'backoffice.myCommunity.inactiveUsers': 'Usuarios Inactivos',
  'backoffice.myCommunity.levelStats': 'Estadísticas Nivel {level}',
  'backoffice.myCommunity.yourProfile': 'Tu Perfil',
  'backoffice.myCommunity.communityMembers': 'Miembros de la Comunidad',
  
  // Filters
  'backoffice.myCommunity.filterByLevel': 'Filtrar por Nivel',
  'backoffice.myCommunity.filterByStatus': 'Filtrar por Estado',
  'backoffice.myCommunity.allLevels': 'Todos los Niveles',
  'backoffice.myCommunity.allStatuses': 'Todos los Estados',
  
  // Error messages
  'backoffice.myCommunity.noDataFound': 'No se encontraron datos de la comunidad',
  'backoffice.myCommunity.errorLoading': 'Error al cargar los datos de la comunidad',
  'backoffice.myCommunity.tryAgain': 'Intentar de nuevo',

  // Table column headers - updated keys
  'backoffice.myCommunity.tableColumns.username': 'Nombre de Usuario',
  'backoffice.myCommunity.tableColumns.name': 'Nombre',
  'backoffice.myCommunity.tableColumns.status': 'Estado',
  'backoffice.myCommunity.tableColumns.rank': 'Rango',
  'backoffice.myCommunity.tableColumns.level': 'Nivel',
  'backoffice.myCommunity.tableColumns.joinDate': 'Fecha de Registro',
  'backoffice.myCommunity.tableColumns.country': 'País',
};
